import { useEffect, useState } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { useFlowManager } from "../../../hooks/useFlowManager";

const PaymentSuccessPage = () => {
  const { goToPostSuccess } = useFlowManager();
  const [count, setCount] = useState(3);

  useEffect(() => {
    let timer = setInterval(() => {
      setCount((c) => Math.max(c - 1, 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (count === 0) {
      goToPostSuccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  useState(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-white px-4">
      <div className="bg-white p-10 rounded-3xl shadow-xl max-w-md w-full text-center border border-green-100 relative overflow-hidden">
        {/* Glow */}
        <div className="absolute inset-0 bg-gradient-to-tr from-green-200/20 to-transparent blur-2xl opacity-40" />

        <div className="flex flex-col items-center relative z-10">
          {/* Checkmark Badge */}
          <div className="w-24 h-24 mb-6 rounded-full flex items-center justify-center bg-green-100 border-2 border-green-300 shadow-md">
            <FiCheckCircle size={55} className="text-green-600" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            Payment Successful!
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-6 max-w-sm">
            Your payment has been processed securely. Redirecting you to the
            property confirmation page.
          </p>

          {/* Countdown */}
          <p className="text-gray-800 font-medium text-lg">
            Redirecting in{" "}
            <span className="text-green-600 font-bold">{count}</span> seconds…
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
